import React from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { OrganizationsState } from './OrganizationsState';
import { Text } from '../components/Text';

export const OrgNameHeading: React.FC = () => {

    const orgsState = useInstance(OrganizationsState);
    const org = orgsState.getMostRecentOrganization();

    if (!orgsState.isOrgTeamMember() || !org) {
        return null;
    }

    return (
        <div data-type="org-name-heading" style={{padding: '12px 10px 5px'}}>
            <Text type="title">{org.name}</Text>
        </div>
    );
};
